import { apiSlice } from './apiSlice';
import { SEARCH_HISTORY_URL } from '../constants';

export const searchHistoryApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getSearchHistory: builder.query({
            query: () => ({
                url: SEARCH_HISTORY_URL,
                method: 'GET',
            }),
            transformResponse: (response) => {
                // Limit to 20 most recent searches (assuming backend returns all)
                if (Array.isArray(response)) {
                    return response
                        .sort((a, b) => new Date(b.searchedAt) - new Date(a.searchedAt))
                        .slice(0, 20);
                }
                return response;
            },
            providesTags: ['SearchHistory'],
        }),
        addSearchTerm: builder.mutation({
            query: (term) => ({
                url: SEARCH_HISTORY_URL,
                method: 'POST',
                body: { term },
            }),
            invalidatesTags: ['SearchHistory'],
        }),
        clearSearchHistory: builder.mutation({
            query: () => ({
                url: SEARCH_HISTORY_URL,
                method: 'DELETE',
            }),
            invalidatesTags: ['SearchHistory'],
        }),
    }),
});

export const {
    useGetSearchHistoryQuery,
    useAddSearchTermMutation,
    useClearSearchHistoryMutation,
} = searchHistoryApiSlice;

